export const setDefaultUrl = (newState) => ({
  type: 'SET_DEFAULT_URL',
  newState,
});

export const setCurrentPage = (newState) => ({
  type: 'SET_CURRENT_PAGE',
  newState,
});
